import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { IMyDpOptions } from "mydatepicker";
import { NgxSpinnerService } from "ngx-spinner";
import { AtbHomeService } from "../../../services/atbHome.service";
import { NgForm } from "@angular/forms";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import swal2 from "sweetalert2";
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { itLocale } from 'ngx-bootstrap/locale';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap';
import { environment } from '../../../../environments/environment';
import swal from "sweetalert2";
defineLocale('it', itLocale)
import * as moment from 'moment';
moment.locale('it')


declare var jQuery: any;

@Component({
  selector: "app-hoteliers-stay-management",
  templateUrl: "./hoteliers-stay-management.component.html",
  styleUrls: ["../../../app.component.css"]
})
export class HoteliersStayManagementComponent implements OnInit {

  locale = 'it';

  hours = [{i:'0',val:'00'},{i:'1',val:'01'},{i:'2',val:'02'},
  {i:'3',val:'03'},{i:'4',val:'04'},
  {i:'5',val:'05'},{i:'6',val:'06'},
  {i:'7',val:'07'},{i:'8',val:'08'},
  {i:'9',val:'09'},{i:'10',val:'10'},
  {i:'11',val:'11'},{i:'12',val:'12'},
  {i:'13',val:'13'},{i:'14',val:'14'},
  {i:'15',val:'15'},{i:'16',val:'16'},
  {i:'17',val:'17'},{i:'18',val:'18'},
  {i:'19',val:'19'},{i:'20',val:'20'},
  {i:'21',val:'21'},{i:'22',val:'22'},
  {i:'23',val:'23'}];

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "dd-mm-yyyy"
  };

  public checkOut: IMyDpOptions = {
    // other options...
    dateFormat: "dd-mm-yyyy"
  };

  public model1: any;
  public model2: any;
  minDateCi: Date;
  minDateCo: Date;

  visibleManage;
  permitsBasePath;
  pathStructure;
  idStructure;
  bsRangeValue: Date[];
  licensePlate;
  pathRoom;
  data: any[] = new Array();
  dataRoom: any[] = new Array();
  dataStay: any[] = new Array();
  dataStayPaged: any[] = new Array();
  dataCheckInTemp;
  dataCheckOutTemp;
  idTempStay;
  dataManage;
  kindManage;
  errorMessage;
  manageStructurePath;
  dataEdit;
  idRoomTemp;
  structureName;
  numPermessiSostaAcquistati;
  bsValue = new Date();
  maxDate = new Date();
  bsValueCheckIn: Date;
  bsValueCheckOut: Date;
  mmCi = ''
  hhCi = ''
  mmCo = ''
  hhCo = ''
  // 15/11: flag per inibire o meno aggiunta soggiorno.
  visualizzaButtonSoggiorno = false;

  numStays = 10;

  @ViewChild("stayForm") formStay: NgForm;

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private atbService: AtbHomeService,
    private localeService: BsLocaleService


  ) {

    this.minDateCi = new Date();
    this.minDateCi.setDate(this.minDateCi.getDate() - 3);
    this.minDateCo = new Date();
    this.minDateCo.setDate(this.minDateCo.getDate() - 3);


    this.localeService.use(this.locale);
    //
    //  this.maxDate.setDate(this.maxDate.getDate() + 7);
    //  this.bsRangeValue = [this.bsValue, this.maxDate];
  }

  ngOnInit() {
    this.permitsBasePath = "permessituristici";
    this.pathStructure = "strutture";
    this.pathRoom = "camere";

    this.manageStructurePath = "soggiorni";
    this.visibleManage = false;
    if (
      localStorage.getItem("nameStructureToCalendar") != null &&
      localStorage.getItem("idStructureToCalendar") != null
    ) {
      this.idStructure = localStorage.getItem("idStructureToCalendar");
      this.structureName = localStorage.getItem("nameStructureToCalendar");
    }

    this.initializeFilters();

    this.structureList(false);
  }

  initializeFilters() {
    const minRangeDate = new Date();
    minRangeDate.setDate(minRangeDate.getDate() - 7);
    const maxRangeDate = new Date();
    maxRangeDate.setDate(maxRangeDate.getDate() + 7);
    this.bsRangeValue = [minRangeDate, maxRangeDate];

    this.licensePlate = '';
  }

  changeM(value, type) {
    if ((parseInt(value) < 0) || (parseInt(value) > 59) || value.length > 2) {
      if(type==1)
        this.mmCi = '0'
      if(type==3)
        this.mmCo = '0'
    }
  }

  changeH(value, type) {
    if ((parseInt(value) < 0) || (parseInt(value) > 23) || value.length > 2) {
      if(type==0)
        this.hhCi = '0'
      if(type==2)
        this.hhCo = '0'
    }
  }

  changeTarga(value) {
    return value.replace(" ", "");

  }

  onDateChanged(stringData) {
    var string = this.atbService.stringToServerFormatCheckIn(
      stringData.formatted
    );

    let copy = this.getCopyOfOptions();
    copy.disableUntil = this.atbService.disableReturnData(string);
    this.checkOut = copy;
  }

  getCopyOfOptions(): IMyDpOptions {
    return JSON.parse(JSON.stringify(this.checkOut));
  }

  getName(id) {
    var name;
    for (let c of this.data) {
      if (c.id == id) {
        name = c.denominazione;
      }
    }

    return name;
  }

  getNumPermessiSostaDisponibili(id) {
    for (let c of this.data) {
      if (c.id == id) {
        return c.numPermessiSosta;
      }
    }
    return null;
  }

  getDisponibilitaAggiuntaSoggiorno(id) {
    for (let c of this.data) {
      if (c.id == id) {
        return c.numPermessiTransito;
      }
    }
    return null;
  }

  OnChangeValue(id) {
    this.idStructure = id;

    this.structureName = this.getName(this.idStructure);

    localStorage.setItem('nameStructureToCalendar', this.structureName);

    if(this.getDisponibilitaAggiuntaSoggiorno(id) != null){
      this.visualizzaButtonSoggiorno = true;
    }else{
      this.visualizzaButtonSoggiorno = false;
    }

    this.initializeFilters();
    
    this.roomList(this.idStructure);
    this.stayList(this.idStructure, this.bsRangeValue, this.licensePlate);
  }

  OnChangeDateRangeValue(dateRange) {
    this.bsRangeValue = dateRange;
  }

  OnChangePlateValue(plate) {
    this.licensePlate = plate;
  }

  search() {
    this.stayList(this.idStructure, this.bsRangeValue, this.licensePlate);
  }

  back() {
    this.visibleManage = false;
    this.dataEdit = null;
    this.formStay.resetForm();
    this.numPermessiSostaAcquistati = null;
    this.structureList(true);
  }

  pageChanged(event) {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.dataStayPaged = this.dataStay.slice(startItem, endItem);
  }

  structureList(isBack) {
    this.spinner.show();

    this.atbService.getListFilter(this.permitsBasePath + '/' + this.pathStructure).subscribe(
      response => {
        // Verificare outcome

        if (response.outcome.success === true) {
          this.data = response.results;

          if (
            isBack == false &&
            localStorage.getItem('idStructureToCalendar') == null && this.data.length > 0
          ) {
            this.idStructure = this.data[0]['id'];
            this.structureName = this.data[0]['denominazione'];

            // 15/11: se numpermessitransito == null inibisco il pulsante perchè:
            // a) la struttura è sita in una zona a varco ZTL e ha bisogno di avere il permesso di transito valido. 
            //Se è scaduto o non ne ha uno associato, non può creare il soggiorno che effettua la richiesta del permesso
            if(this.data[0]['numPermessiTransito'] != null)
              this.visualizzaButtonSoggiorno = true;
          }

          if (this.data.length > 0 ) {
            this.roomList(this.idStructure);
            this.stayList(this.idStructure, this.bsRangeValue, this.licensePlate);
          } else{
            swal2('Attenzione Nessuna Struttura è stata registrata', '', 'warning')
            this.router.navigate(['/hoteliers/structure/new']);
            this.spinner.hide();
          }
        } else {
          this.spinner.hide();
        }
      },
      error => {
        console.log('Error ', error);
        swal2('Attenzione Nessuna Struttura è stata registrata', '', 'warning')
        this.router.navigate(['/hoteliers/structure/new']);
        // this.goToAtbAtHome();
        this.spinner.hide();
      }
    );
  }

  stayList(id, dateRange, licensePlate) {
    this.spinner.show();

    const startDate = moment(dateRange[0]).format('YYYY-MM-DD');
    const endDate = moment(dateRange[1]).format('YYYY-MM-DD');
    const plate = this.changeTarga(licensePlate);

    this.atbService.getListFilter(this.permitsBasePath + '/' + this.manageStructurePath + '/' + id +
      "?dataInizio=" + startDate + "&dataFine=" + endDate + (plate ? "&targa=" + plate : "")).subscribe(
      response => {
        // Verificare outcome
        if (response.outcome.success === true) {
          this.dataStay = response.results;
          this.dataStayPaged = this.dataStay.slice(0, 10);
        } else {
        }
        this.spinner.hide();
      },
      error => {
        console.log('Error ', error);
        // this.goToAtbAtHome();
        this.spinner.hide();
      }
    );
  }

  roomList(id) {
    this.atbService.getListFilter(this.permitsBasePath + '/' + this.pathRoom + '/' + id).subscribe(
      response => {
        // Verificare outcome
        if (response.outcome.success === true) {
          this.dataRoom = response.results;
        } else {
        }
      },
      error => {
        console.log('Error ', error);
        // this.goToAtbAtHome();
      }
    );
  }

  goToCalendar() {
    localStorage.setItem('idStructureToCalendar', this.idStructure);
    localStorage.setItem('nameStructureToCalendar', this.structureName);

    this.router.navigate(['/hoteliers/permits/calendar']);
  }

  open() {
    jQuery('#sidebar').toggleClass('active');
  }

  newStay() {
    this.bsValueCheckIn = null;
    this.bsValueCheckOut = null;
    this.visibleManage = true;
    this.kindManage = 1;
    this.numPermessiSostaAcquistati = this.getNumPermessiSostaDisponibili(this.idStructure);
  }

  editStay(dataEdit, id) {
    this.visibleManage = true;
    this.kindManage = 0;
    this.dataEdit = dataEdit;

    this.idTempStay = id;
    this.idRoomTemp = dataEdit.idCamera;
    this.numPermessiSostaAcquistati = this.getNumPermessiSostaDisponibili(this.idStructure);

    this.maxDate = this.atbService.fromStringToDate(
      this.dataEdit['dataCheckIn']
    );
    this.bsValue = this.atbService.fromStringToDate(
      this.dataEdit['dataCheckOut']
    );

    this.dataEdit['targa'] = this.changeTarga(this.dataEdit['targa'])

    this.dataCheckInTemp = this.dataEdit['dataCheckIn'];
    /*this.dataEdit['dataCheckIn'] = this.atbService.fromStringToDataFormatted(
      this.dataEdit['dataCheckIn']
    );*/

    this.hhCi = this.atbService.fromStringToTimeHourFormatted(
      this.dataEdit['dataCheckIn']
    );

    this.mmCi = this.atbService.fromStringToTimeMinFormatted(
      this.dataEdit['dataCheckIn']
    );

    this.hhCo = this.atbService.fromStringToTimeHourFormatted(
      this.dataEdit['dataCheckOut']
    );

    this.mmCo = this.atbService.fromStringToTimeMinFormatted(
      this.dataEdit['dataCheckOut']
    );


    this.bsValueCheckIn = this.maxDate;
    this.bsValueCheckOut = this.bsValue;

    this.dataCheckOutTemp = this.dataEdit['dataCheckOut'];
    this.dataEdit['dataCheckOut'] = this.atbService.fromStringToDataFormatted(
      this.dataEdit['dataCheckOut']
    );
    this.model2 = this.dataEdit['dataCheckOut'];
    this.model1 = this.dataEdit['dataCheckIn'];
  }

  deleteStay(id) {
    swal({
      title: 'Conferma Cancellazione',
      text: 'Sei sicuro di voler cancellare il soggiorno?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Cancella',
      cancelButtonText: 'Annulla',
      focusCancel: true
    }).then(result => {
      if (result.value) {
        this.spinner.show();
        this.atbService.delete(this.permitsBasePath + '/' + this.manageStructurePath + '/' + id).subscribe(
          response => {
            if (response.outcome.success === true) {
              // swal2("Nuovo veicolo creato", "", "success");
              //  this.router.navigate(['/hoteliers/structure/structures']);
              this.stayList(this.idStructure, this.bsRangeValue, this.licensePlate);
            } else {
              this.errorMessage = 'Credenziali non valide.';
              //   swal2("Attenzione", "Credenziali non valide", "warning");
              this.spinner.hide();
            }
          },
          error => {
            //   this.logger.log("Error", error, 200);
            this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
            /*  swal2(
            "Errore",
              "Spiacente, si è verificato un errore tecnico.",
              "error"
            );*/
            this.spinner.hide();
          }
        );
      }
    });
  }

  manageStay() {
    if (this.kindManage == 1) {
      this.spinner.show();
      this.dataManage = this.formStay.value;

      this.dataManage['id'] = null;
      //  this.dataManage['id'] = this.idStructure

      this.dataManage['dataCheckIn'] = this.atbService.DataToServerFormat(
        this.bsValueCheckIn,
        " " + this.hhCi + ':' + this.mmCi + ':00'
      );
      this.dataManage['dataCheckOut'] = this.atbService.DataToServerFormat(
        this.bsValueCheckOut,
        " " + this.hhCo + ':' + this.mmCo + ':00'
      );


      this.dataManage['targa'] = this.changeTarga(this.dataManage['targa'])
      //cancello data ora e minuti
      delete this.dataManage['bsValueCheckIn'];
      delete this.dataManage['bsValueCheckOut'];
      delete this.dataManage['timeHourCi'];
      delete this.dataManage['timeHourCo'];
      delete this.dataManage['timeMinCi'];
      delete this.dataManage['timeMinCo'];

      this.atbService.newObject(this.dataManage, this.permitsBasePath + '/' + this.manageStructurePath).subscribe(
        response => {
          if (response.outcome.success === true) {
            // swal2("Nuovo veicolo creato", "", "success");
            //  this.router.navigate(['/hoteliers/structure/structures']);
            this.back();
          } else {
            if (response.outcome.code == '0011') {

              // tslint:disable-next-line:max-line-length
              if (response.outcome.description.indexOf('DATA CHECK-IN NON VALIDA') >= 0) {
                this.errorMessage = response.outcome.message;
              } else if (response.outcome.description == 'CAMERA OCCUPATA') {
                this.errorMessage = 'La Camera risulta essere già occupata';
              } else if (response.outcome.description == 'PERMESSO NON VALIDO') {
                this.errorMessage = 'Il permesso non risulta essere valido per le date selezionate';
              } else {
                this.errorMessage = 'La Struttura non risulta attiva';
              }

            } else if (response.outcome.code == '0013' || response.outcome.code == '0031') {

              this.errorMessage = response.outcome.message;

            } else {
              this.errorMessage = 'Qualcosa è andato storto';
            }

            swal2('Attenzione', this.errorMessage, 'warning');
            this.spinner.hide();
          }
        },
        error => {
          //   this.logger.log("Error", error, 200);
          this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
          /*  swal2(
      "Errore",
      "Spiacente, si è verificato un errore tecnico.",
      "error"
    );*/
          this.spinner.hide();
        }
      );
    } else {
      this.dataManage = this.formStay.value;
//
     // if (
     //   this.formStay.value.dataCheckIn.formatted == null ||
     //   this.formStay.value.dataCheckIn.formatted == undefined
     // ) {
     //   this.dataManage["dataCheckIn"] = this.dataCheckInTemp;
     // } else {
     //   this.dataManage["dataCheckIn"] = this.atbService.stringToServerFormat(
     //     this.formStay.value.dataCheckIn.formatted,
     //     " 00:00:00"
     //   );
     // }

     // if (
     //   this.formStay.value.dataCheckOut.formatted == null ||
     //   this.formStay.value.dataCheckOut.formatted == undefined
     // ) {
     //   this.dataManage["dataCheckOut"] = this.dataCheckOutTemp;
     // } else {
     //   this.dataManage["dataCheckOut"] = this.atbService.stringToServerFormat(
     //     this.formStay.value.dataCheckOut.formatted,
     //     " 14:00:00"
     //   );
     // }
     var varDataCi = this.bsValueCheckIn
     var varDataCo = this.bsValueCheckOut

     this.dataManage['dataCheckIn'] = this.atbService.DataToServerFormat(
        varDataCi,
        " " + this.hhCi + ':' + this.mmCi + ':00'
      );
      this.dataManage['dataCheckOut'] = this.atbService.DataToServerFormat(
        varDataCo,
        " " + this.hhCo + ':' + this.mmCo + ':00'
      );

      this.dataManage['id'] = this.idTempStay;
      this.dataManage['idCamera'] = this.idRoomTemp;
      this.dataManage['targa'] = this.changeTarga(this.dataManage['targa']);
      //  this.dataManage['id'] = this.idStructure
      delete this.dataManage['bsValueCheckIn'];
      delete this.dataManage['bsValueCheckOut'];
      delete this.dataManage['timeHourCi'];
      delete this.dataManage['timeHourCo'];
      delete this.dataManage['timeMinCi'];
      delete this.dataManage['timeMinCo'];

      this.atbService.edit(this.dataManage, this.permitsBasePath + '/' + this.manageStructurePath).subscribe(
        response => {
          if (response.outcome.success === true) {
            this.back();

            swal2('Il soggiorno è stato modificato', '', 'success');
          } else {
            if (response.outcome.code == '0011') {

              // tslint:disable-next-line:max-line-length
              if (response.outcome.description.indexOf('DATA CHECK-IN NON VALIDA') >= 0) {
                this.errorMessage = response.outcome.message;
              } else if (response.outcome.description == 'CAMERA OCCUPATA') {
                this.errorMessage = 'La Camera risulta essere già occupata';
              } else if (response.outcome.description == 'PERMESSO NON VALIDO') {
                this.errorMessage = 'Il permesso non risulta essere valido per le date selezionate';
              } else if (response.outcome.description.indexOf('SOGGIORNO NON MODIFICABILE') >= 0) {
                this.errorMessage = response.outcome.message;
              } else {
                this.errorMessage = 'La Struttura non risulta attiva';
              }

            } else if (response.outcome.code == '0013' || response.outcome.code == '0031') {

              this.errorMessage = response.outcome.message;

            } else {
              this.errorMessage = 'Qualcosa è andato storto';
            }

            swal2(
              'Attenzione',
              'Il soggiorno non è stato modificato (' + this.errorMessage + ')',
              'warning'
            );
            this.spinner.hide();
          }
        },
        error => {
          // this.logger.log("Error", error, 200);
          this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
          this.spinner.hide();
        }
      );
    }
  }
  
  formatDate(obj) {
    return moment(obj).toISOString();
  }


  getPdfPermitParking(id) {
    var link = document.createElement('a');
              link.href = environment.baseUrl + 'download?id=' + id + '&type=sostapermeturi';
              link.download = 'Permesso_' + id + '.pdf';
              link.click();

/*
    this.atbService
      .getFilePdf('download?id=' + id + '&type=sostapermeturi')
      .subscribe(
        response => {
          if (response) {
            console.log('RISPOSTA', response);


            var blob = new Blob([response], { type: 'application/pdf' });
            var ieEDGE = navigator.userAgent.match(/Edge/g);
            var ie = navigator.userAgent.match(/.NET/g); // IE 11+
            var oldIE = navigator.userAgent.match(/MSIE/g);

            console.log('COSA E?', ieEDGE);
            console.log(blob);
            if (ie || oldIE || ieEDGE) {
              console.log(' EDGE !');
              window.navigator.msSaveOrOpenBlob(blob, 'myPDFdoc.pdf');
            } else {
              console.log(' NON E\' EDGE !');
              var url = window.URL.createObjectURL(blob);
              //   window.open(url);

              //   window.navigator.msSaveOrOpenBlob(blob, 'myPDFdoc.pdf');

              var link = document.createElement('a');
              link.href = url;
              link.download = 'file.pdf';
              link.click();
            }
            swal2('Il permesso è stato scaricato con successo', '', 'success');
          } else {
          }
        },
        error => {
          console.log('RISPOSTA', error);
          swal2(
            'Errore',
            'Spiacente, si è verificato un errore tecnico.',
            'error'
          );
        }
      );
      */
  }

  getPdfPermitTransit(id) {
    var link = document.createElement('a');
              link.href = environment.baseUrl + 'download?id=' + id + '&type=transitopermeturi';
              link.download = 'Permesso_' + id + '.pdf';
              link.click();
  }
}



// WEBPACK FOOTER //
// ./src/app/views/hoteliers-permits/hoteliers-stay-management/hoteliers-stay-management.component.ts